import { useState, useRef, useEffect } from "react";
import { useLang, LANGUAGES } from "@/i18n";
import { ChevronDown } from "lucide-react";
import { useLandingTheme } from "@/context/LandingThemeContext";

export default function LangSelector() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  let L = false;
  try { const ctx = useLandingTheme(); L = ctx?.theme === "light"; } catch {}

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid="lang-selector">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium transition-all duration-200"
        style={{
          background: L ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.04)",
          border: `1px solid ${L ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)"}`,
          color: L ? "rgba(0,0,0,0.7)" : "rgba(255,255,255,0.8)",
        }}
      >
        <span className="text-base">{current.flag}</span>
        <span className="hidden sm:inline">{current.label}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          className="absolute right-0 top-full mt-2 w-44 rounded-xl overflow-hidden z-50"
          style={{
            background: "rgba(15,23,42,0.97)",
            border: "1px solid rgba(255,255,255,0.1)",
            boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
            backdropFilter: "blur(20px)",
          }}
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              data-testid={`lang-${l.code}`}
              className="w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors"
              style={{
                background: lang === l.code ? "rgba(249,115,22,0.1)" : "transparent",
                color: lang === l.code ? "#f97316" : "rgba(255,255,255,0.7)",
                borderBottom: "1px solid rgba(255,255,255,0.05)",
              }}
              onMouseEnter={(e) => { if (lang !== l.code) e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
              onMouseLeave={(e) => { if (lang !== l.code) e.currentTarget.style.background = "transparent"; }}
            >
              <span className="text-lg">{l.flag}</span>
              <span className="font-medium">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
